import Select from "@/components/Select";
import React from "react";
import { Comparator, comparatorDefs, SerializedCondition } from "../types";
import Input from "@/components/Input";
import RegexPatternInput from "./RegexPatternInput";

export type UrlCondition = {
  url: string;
  comparator: Comparator;
};

export function UrlEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const urlCondition = JSON.parse(condition.data || "{}") as UrlCondition;

  function update(data: UrlCondition) {
    onUpdate({ ...condition, data: JSON.stringify(data) });
  }

  const validComparatorOptions: Record<string, string> = {
    equals: comparatorDefs.equals,
    notEquals: comparatorDefs.notEquals,
    contains: comparatorDefs.contains,
    notContains: comparatorDefs.notContains,
    regex: comparatorDefs.regex,
    notRegex: comparatorDefs.notRegex
  };

  const isRegex =
    urlCondition.comparator === "regex" ||
    urlCondition.comparator === "notRegex";

  return (
    <>
      <Select
        options={validComparatorOptions}
        value={urlCondition.comparator}
        onChange={(v) => update({ ...urlCondition, comparator: v })}
      />
      {isRegex ? (
        <RegexPatternInput
          value={urlCondition.url || ""}
          onChange={(v) => update({ ...urlCondition, url: v })}
          placeholder="e.g. ^/pricing/.*\?plan=enterprise"
          hint="Matches the full page URL. Case-insensitive."
          examples={[
            "^/pricing/.*\\?plan=enterprise",
            "^/(shop|store|products)/",
            "\\.pdf(\\?.*)?$"
          ]}
        />
      ) : (
        <Input
          className="w-full border rounded-md p-2"
          value={urlCondition.url}
          onChange={(v) => update({ ...urlCondition, url: v })}
        />
      )}
    </>
  );
}
